export const cssUrl = (url?: string | null) => {
  if (!url) return undefined;
  return `url(${url})`;
};
